<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Homepage',
  computed: {
  ...mapGetters(['getUserFactType', 'getUserFactSubType']),
  },
  created() {
    this.redirectByFact()
  },
  methods: {
    redirectByFact(){
      let userFactType = this.getUserFactType
      let userFactSubType = this.getUserFactSubType
      if(userFactType == '80' && userFactSubType == '80'){
        let link = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=123`
        window.location.href = link
      } else {
        let link = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=122`
        window.location.href = link
      }
    }
  },
}
</script>
